<div class="chatbot-container">
  <!-- Chatbot Floating Action Button -->
  <button
    type="button"
    class="chatbot-fab"
    (click)="toggleChatbot()"
    [matTooltip]="'chatbot.title' | translate"
    matTooltipPosition="above"
    [attr.aria-label]="'chatbot.title' | translate">
    <mat-icon class="fab-icon">chat_bubble</mat-icon>
  </button>

  <!-- Chatbot Window -->
  <div
    *ngIf="isOpen && !isMinimized"
    class="chatbot-window"
    role="region"
    [attr.aria-label]="'chatbot.aria.chatWindow' | translate">
    
    <!-- Window Header -->
    <div class="chatbot-header">
      <div class="chatbot-title">{{ 'chatbot.title' | translate }}</div>
      <div class="chatbot-header-actions">
        <button
          type="button"
          class="header-btn minimize-btn"
          (click)="minimizeChatbot()"
          [attr.aria-label]="'chatbot.aria.minimize' | translate"
          [title]="'chatbot.minimize' | translate">
          <mat-icon>remove</mat-icon>
        </button>
        <button
          type="button"
          class="header-btn close-btn"
          (click)="onCloseClick()"
          [attr.aria-label]="'chatbot.aria.close' | translate"
          [title]="'chatbot.close' | translate">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <!-- Messages Container -->
    <div class="chatbot-messages" #messagesScrollContainer>
      <ng-container *ngFor="let msg of messages">
        <!-- Welcome Message Card -->
        <div *ngIf="msg.isWelcome" class="message-card welcome-card">
          <div class="welcome-header">
            <strong>
              <ng-container *ngIf="userFirstName; else noName">
                {{ 'chatbot.welcome.greeting' | translate: { name: userFirstName } }}
              </ng-container>
              <ng-template #noName>
                {{ 'chatbot.welcome.greetingNoName' | translate }}
              </ng-template>
            </strong>
          </div>
          <div class="welcome-subtitle">{{ 'chatbot.welcome.subtitle' | translate }}</div>
        </div>

        <!-- Normal Bot Message -->
        <div *ngIf="!msg.isWelcome && msg.sender === 'bot'" class="message-row bot-row">
          <div class="message-bubble bot-bubble" [innerHTML]="formatMessage(msg.text)">
          </div>

          <!-- Feedback Option (Becomes available 1 minute after response per AC 5 & AC 6) -->
          <div *ngIf="msg.showFeedback" class="feedback-container">
            <div class="feedback-prompt">
              <span class="feedback-label">{{ 'chatbot.feedback.prompt' | translate }}</span>
              <button
                type="button"
                class="feedback-btn"
                [class.selected]="msg.selectedFeedback === 'up'"
                [disabled]="msg.feedbackSubmitted"
                (click)="submitFeedback(msg, 'up')"
                [attr.aria-label]="'chatbot.feedback.helpful' | translate"
                [title]="'chatbot.feedback.helpful' | translate">
                👍
              </button>
              <button
                type="button"
                class="feedback-btn"
                [class.selected]="msg.selectedFeedback === 'down'"
                [disabled]="msg.feedbackSubmitted"
                (click)="submitFeedback(msg, 'down')"
                [attr.aria-label]="'chatbot.feedback.notHelpful' | translate"
                [title]="'chatbot.feedback.notHelpful' | translate">
                👎
              </button>
            </div>
            <div *ngIf="msg.feedbackSubmitted" class="feedback-thankyou">
              {{ 'chatbot.feedback.thankYou' | translate }}
            </div>
          </div>
        </div>

        <!-- User Message -->
        <div *ngIf="msg.sender === 'user'" class="message-row user-row">
          <div class="message-bubble user-bubble">
            {{ msg.text }}
          </div>
        </div>
      </ng-container>

      <!-- Bot Typing Indicator -->
      <div *ngIf="isBotTyping" class="message-row bot-row typing-indicator-row">
        <div class="message-bubble bot-bubble typing-bubble">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
      </div>
    </div>

    <!-- Footer / Input Area -->
    <div class="chatbot-footer">
      <form class="chatbot-input-form" (ngSubmit)="sendMessage()">
        <input
          type="text"
          class="chatbot-input"
          [placeholder]="'chatbot.input.placeholder' | translate"
          [(ngModel)]="inputMessage"
          name="chatInput"
          (keydown)="onKeyDown($event)"
          autocomplete="off" />
        <button
          type="submit"
          class="chatbot-send-btn"
          [disabled]="!inputMessage.trim()">
          {{ 'chatbot.input.send' | translate }}
        </button>
      </form>
    </div>
  </div>
</div>

<!-- Close Confirmation Dialog Template -->
<ng-template #closeConfirmDialog>
  <div class="chatbot-confirm-dialog">
    <h3 class="confirm-dialog-title">{{ 'chatbot.confirmDialog.title' | translate }}</h3>
    <div class="confirm-dialog-body">
      {{ 'chatbot.confirmDialog.message' | translate }}
    </div>
    <div class="confirm-dialog-actions">
      <button
        type="button"
        class="confirm-btn btn-no"
        (click)="cancelClose()">
        {{ 'chatbot.confirmDialog.no' | translate }}
      </button>
      <button
        type="button"
        class="confirm-btn btn-yes"
        (click)="confirmClose()">
        {{ 'chatbot.confirmDialog.yes' | translate }}
      </button>
    </div>
  </div>
</ng-template>
